import CustomEmailInput from "./forms/CustomEmailInput";

export default function SignUpCTA({ data, isDesc }) {
  const appMode = process.env.APP_MODE;
  const link = data?.form?.submit?.href?.[appMode] || data?.form?.submit?.href;
  return (
    <section className="signup-cta-section lg:pt-10 lg:pb-10">
      <div className="signup-cta-warper mx-auto">
        <h2 className="text-lg">{data.title}</h2>
        {isDesc && <p>{data.desc}</p>}
        <CustomEmailInput
          id="indexEmailFooterForm"
          data-testid={
            process.env.APP_MODE === "live"
              ? "signup-cta-sign-up-live"
              : "signup-cta-sign-up-staging"
          }
          action={link}
          data={data.form}
          isAutoFocus={false}
          submitButtonId="start-free-button-cta-fold"
        />
      </div>
    </section>
  );
}
